import { buildLocalBusinessSchema } from "@/components/SeoLandingPage";
import { buildBreadcrumbSchema, ldScript, SITE_URL } from "@/lib/page-schema";

export const STORY_EN = `${SITE_URL}/our-story`;
export const STORY_ES = `${SITE_URL}/es/nuestra-historia`;

export const storyAlternates = [
  { rel: "alternate", hrefLang: "en-US", href: STORY_EN },
  { rel: "alternate", hrefLang: "es-US", href: STORY_ES },
  { rel: "alternate", hrefLang: "x-default", href: STORY_EN },
];

export function storyScripts({
  url,
  name,
  description,
  inLanguage,
  crumbs,
}: {
  url: string;
  name: string;
  description: string;
  inLanguage: string;
  crumbs: { name: string; path: string }[];
}) {
  const business = buildLocalBusinessSchema({
    url,
    name: "Atlanta Luxury Sprinters",
    image: `${SITE_URL}/favicon.ico`,
    description,
    serviceType: "Luxury Chauffeured Transportation",
    areaServed: [{ type: "City", name: "Atlanta" }],
  });
  return [
    ldScript(business),
    ldScript({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      url,
      name,
      description,
      inLanguage,
      about: { "@id": business["@id"] },
      mainEntity: { "@id": `${url}#maria-priestly` },
    }),
    ldScript({
      "@context": "https://schema.org",
      "@type": "Person",
      "@id": `${url}#maria-priestly`,
      name: "Maria Priestly",
      jobTitle: "Founder and Owner",
      worksFor: { "@id": business["@id"] },
      founder: undefined,
    }),
    ldScript(buildBreadcrumbSchema(crumbs)),
  ];
}
